import { useState } from "react";
import { format, parse } from "date-fns";
import { hr } from "date-fns/locale";
import { CalendarIcon, X } from "lucide-react";
import { Button } from "./ui/button";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

export const DatePickerHR = ({ value, onChange, placeholder = "dd.mm.gggg.", className = "", "data-testid": testId }) => {
  const [open, setOpen] = useState(false);
  const selected = value ? parse(value, "yyyy-MM-dd", new Date()) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          data-testid={testId}
          className={`justify-start font-normal rounded-sm bg-white border-[#CBD5E1] hover:bg-[#F1F5F9] ${!selected ? "text-[#64748B]" : "text-[#0F172A]"} ${className}`}
        >
          <CalendarIcon className="w-4 h-4 mr-2 text-[#64748B]" />
          <span className="tabular-nums">{selected ? format(selected, "dd.MM.yyyy.") : placeholder}</span>
          {selected && (
            <span
              role="button"
              data-testid={testId ? `${testId}-clear` : undefined}
              className="ml-auto pl-2 text-[#64748B] hover:text-[#DC2626]"
              onClick={(e) => { e.stopPropagation(); onChange(""); }}
            >
              <X className="w-3.5 h-3.5" />
            </span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          locale={hr}
          weekStartsOn={1}
          selected={selected}
          defaultMonth={selected}
          onSelect={(d) => { onChange(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); }}
        />
      </PopoverContent>
    </Popover>
  );
};
